import React, { useEffect, useRef, useState } from 'react'
import { http } from '@ud/admin-framework'
import QRCode from 'qrcode.react'

import './index.less'
import { notification, Spin } from 'antd'
import { CheckCircleOutlined, LoadingOutlined, ReloadOutlined, SyncOutlined } from '@ant-design/icons'

const QrCodeLogin: React.FC<IQrCodeLoginProps> = (props) => {

  let DEVICE_ID: any = ''
  if (localStorage.getItem('DEVICE_ID')) {
    DEVICE_ID = localStorage.getItem('DEVICE_ID')
  } else {
    DEVICE_ID = '' + (Math.random() * 10000).toFixed(0) + new Date().valueOf()
    localStorage.setItem('DEVICE_ID', DEVICE_ID)
  }


  const loopTime = 2000

  const [qrCodeInfo, setQrCodeInfo] = useState<IQrCodeInfo | null>(null)

  const [loading, setLoading] = useState<boolean>(true)

  const timer = useRef<any>(null)

  const faildTimes = useRef<number>(0)

  useEffect(() => {
    getQrCode()
    return () => {
      clearTimer()
    }
  }, [])

  useEffect(() => {
    if (qrCodeInfo) {
      loopResult()
    }
  }, [qrCodeInfo])

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current)
    }
  }

  // 获取二维码code
  const getQrCode = () => {
    if (qrCodeInfo?.status === 'NORMAL') {
      return false
    }
    clearTimer()
    setLoading(true)
    const url = '/public/v1/qrCode/generate'
    const params = {
      deviceId: DEVICE_ID,
      action: 'LOGIN',
      terminal: '1919-BMS'
    }
    http.get(url, { params }).then(res => {
      const data = res.data || {}
      if (!data.url) {
        faildTimes.current = 0
        setQrCodeInfo({
          status: 'ERROR',
          statusMsg: '二维码加载失败，请重试',
          id: '',
          url: '',
        })
      } else {
        setQrCodeInfo({
          ...data,
          status: 'NORMAL'
        })
      }
    }).catch(() => {
      setQrCodeInfo({
        status: 'ERROR',
        statusMsg: '二维码加载失败，请重试',
        id: '',
        url: '',
      })

      // setQrCodeInfo({
      //   status: 'NORMAL',
      //   statusMsg: '',
      //   // msg: '测试文案',
      //   id: '121212',
      //   url: 'https://uaa-gateway-test.1919.cn/restapi/v1/qrCode/getInfo?qrId=1',
      // })
    })
      .finally(() => {
        setLoading(false)
      })
  }

  const getResult = () => {
    if (!qrCodeInfo?.id) {
      return
    }
    const url = '/public/v1/qrCode/getConfirmResult'
    const params = { qrId: qrCodeInfo.id, deviceId: DEVICE_ID, withCredentials: true, secure: true, sameSite: "None" }
    http.defaults.withCredentials = true;
    http.get(url, { params }).then(res => {
      const data = (res.data || {}) as IResult

      if (data.confirmed) {
        clearTimer()
        // 用户已确认，走登录逻辑

        try {
          const tokenData = JSON.parse(data.metadata)
          props.onSuccess(tokenData)
        } catch {
          notification.error({
            message: '登录失败',
            description: '登录数据异常，请刷新后重新扫码'
          })
          setQrCodeInfo({
            ...qrCodeInfo,
            status: 'ERROR',
            statusMsg: '登录数据异常，请刷新后重新扫码'
          })
        }
        return
      }
      if (data.scanned) {
        setQrCodeInfo({
          ...qrCodeInfo,
          status: 'SCANNED',
          statusMsg: data.msg || '扫码成功'
        })
      }
      if (data.retryAble) {
        loopResult()
      } else {
        clearTimer()
        setQrCodeInfo({
          ...qrCodeInfo,
          status: 'EXPIRED',
          statusMsg: data.msg || '二维码已失效'
        })
      }
    }).catch(() => {
      if (faildTimes.current >= 4) {

        faildTimes.current = 0
        clearTimer()
        setQrCodeInfo({
          ...qrCodeInfo,
          status: 'EXPIRED',
          statusMsg: '服务异常，请刷新后重试'
        })
        return false
      }
      faildTimes.current += 1
      loopResult(faildTimes.current * 4000)
    })
  }

  // 轮询扫码结果
  const loopResult = (delay?: number) => {
    clearTimer()
    if (!qrCodeInfo || !qrCodeInfo.url) {
      return
    }
    timer.current = setTimeout(() => {
      getResult()
    }, delay || loopTime)
  }

  // 获取蒙层内容（二维码不同状态）
  const getMaskContent = () => {
    if (loading || !qrCodeInfo) {
      return (
        <div className='get-qrcode-error'></div>
      )
    }
    if (qrCodeInfo?.status === 'ERROR') {
      return (
        <div className='get-qrcode-error'>
          <ReloadOutlined className='retry-icon' onClick={() => { getQrCode() }} />
          <div style={{ color: '#666', marginTop: '10px' }}>{qrCodeInfo.statusMsg || '二维码加载失败，请重试'}</div>
        </div>
      )
    }
    if (qrCodeInfo?.status === 'EXPIRED') {
      return (
        <div className='get-qrcode-error'>
          <ReloadOutlined className='retry-icon' onClick={() => { getQrCode() }} />
          <div style={{ color: '#666', marginTop: '10px' }}>{qrCodeInfo.statusMsg || '二维码已失效'}</div>
        </div>
      )
    }
    if (qrCodeInfo?.status === 'SCANNED') {
      return (
        <div className='get-qrcode-error'>
          <CheckCircleOutlined className='retry-icon' style={{ color: '#49CC90' }} onClick={() => { getQrCode() }} />
          <div style={{ color: '#666', marginTop: '10px' }}>{qrCodeInfo.statusMsg || '扫码成功'}</div>
        </div>
      )
    }
    return null
  }

  return (
    <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} delay={400}>
      <div className="qrcode-login">
        <div className="code-wrap">

          <div className="code">
            {getMaskContent()}
            {
              qrCodeInfo?.url &&
              <QRCode
                value={qrCodeInfo.url}
                size={174}
                fgColor="#000000"
              />
            }

          </div>

          <div className="tips">{qrCodeInfo?.msg || '请使用掌上门店扫码登录'}&emsp;
            <a className='refresh-op' onClick={() => { getQrCode() }}><SyncOutlined style={{ marginTop: '8px' }} />刷新</a>
          </div>


        </div>
      </div>
    </Spin>
  )
}

interface IQrCodeLoginProps {
  onSuccess: (data: any) => void
}

interface IQrCodeInfo {
  url: string
  id: string
  status: 'ERROR' | 'NORMAL' | 'SCANNED' | 'EXPIRED', // 二维码状态
  msg?: string // 底部二维码使用提示文案
  statusMsg?: string // 二维码状态提示文案
  expiredAt?: string // 过期时间（暂未使用）
}

interface IResult {
  confirmed: boolean
  id: string
  metadata: any
  msg: string // 二维码状态提示文案
  retryAble: boolean // 是否可重试
  scanned: boolean // 是否扫码
}



export default QrCodeLogin
